import { EndpointPermissionRule } from '../core/permissions/endpoint-permission.models';
import { P } from './portal-permissions.constants';

/** Backend geçişi: katalog Raporlar.* + mevcut ReportView.* grant'ları */
const EMISYON = [P.Raporlar.Emisyon, 'Raporlar.Emisyon'];
/** Grup Şirketleri (eski: Kategoriye Göre Emisyon) — Analiz + legacy Raporlar */
const GRUP_SIRKETLERI = [
  P.Analiz.GrupSirketleri,
];

function multiRead(
  pattern: string,
  permissionKeys: string[],
  methods: ('GET' | 'POST')[] = ['GET', 'POST'],
): EndpointPermissionRule[] {
  return methods.map((method) => ({
    method,
    pattern,
    permissionKeys,
    access: 'read' as const,
  }));
}

function multiWrite(
  pattern: string,
  permissionKeys: string[],
  methods: ('GET' | 'POST')[] = ['POST'],
): EndpointPermissionRule[] {
  return methods.map((method) => ({
    method,
    pattern,
    permissionKeys,
    access: 'write' as const,
  }));
}

export const RAPORLAR_ENDPOINT_EXTRA_RULES: readonly EndpointPermissionRule[] =
  [
    ...multiRead('api/Emission/GetApplicationEmissionDataByCategory', [
      ...GRUP_SIRKETLERI,
    ]),

    ...multiRead('api/Company/GetLocations', [
      ...EMISYON,
      P.Yonetim.Lokasyonlar,
    ]),

    /* --- Emisyon raporu (read) --- */
    ...multiRead('api/Reports/GetReportTypes', EMISYON, ['GET']),
    ...multiRead('api/Reports/GetDraftReports', EMISYON, ['GET']),
    ...multiRead('api/Reports/GetReportById', EMISYON, ['GET']),
    ...multiRead('api/Reports/GetAllReports', EMISYON, ['GET']),
    ...multiRead('api/Reports/GetReportNodes', EMISYON, ['GET']),
    ...multiRead('api/Reports/GetReportsByType', EMISYON, ['GET']),
    ...multiRead('api/Reports/GetReportTypeTemplates', EMISYON, ['GET']),
    ...multiRead('api/Reports/GetTemplateForReport', EMISYON, ['GET']),
    ...multiRead('api/Reports/PreviewHtml', EMISYON),
    ...multiRead('api/Reports/ExportPdf', EMISYON),

    /* --- Emisyon raporu (write) --- */
    ...multiWrite('api/Reports/CreateReport', EMISYON),
    ...multiWrite('api/Reports/CreateReportV2', EMISYON),
    ...multiWrite('api/Reports/DeleteReport', EMISYON),
    ...multiWrite('api/Reports/ExecuteReport', EMISYON),
    ...multiWrite('api/Reports/UpdateReportNode', EMISYON),
    ...multiWrite('api/Reports/AddReportNode', EMISYON),
    ...multiWrite('api/Reports/RemoveReportNode', EMISYON),
    ...multiWrite('api/Reports/ReorderReportNode', EMISYON),
    ...multiWrite('api/Reports/AddReportNodeTemplate', EMISYON),
    ...multiWrite('api/Reports/UpdateReportNodeTemplate', EMISYON),
    ...multiWrite('api/Reports/DeleteReportNodeTemplate', EMISYON),
    ...multiWrite('api/Reports/ReorderReportNodeTemplates', EMISYON),
    ...multiWrite('api/Reports/UploadTemplate', EMISYON),
    ...multiWrite('api/Reports/CreateTemplate', EMISYON),
  ];
